import { element } from 'prop-types';
import { lazy } from 'react';
import FastLaneHubView from '../views/pages/Dashboard/PricingRules/FastLaneView/FastLaneHubView';
import PayPhoneHubView from '../views/pages/Dashboard/PricingRules/CallPassView/PayPhoneHubView';
import VippHubView from '../views/pages/Dashboard/PricingRules/VippView/VippHubView';
import VtnaHubView from '../views/pages/Dashboard/PricingRules/VtnaView/VtnaHubView';
const AccountsV2 = lazy(() => import('../views/pages/Dashboard/Settings/Account-v2'));
const AccountsV2Details = lazy(() =>
  import('../views/pages/Dashboard/Settings/Account-v2/Details')
);
const APIDocumentation = lazy(() =>
  import('../views/pages/Documentation/API/APIDocumentationView')
);
const Reports = lazy(() => import('../views/pages/Dashboard/Reports/Reports'));
const PageNotFound = lazy(() => import('../views/pages/PageNotFound'));
const WorkInProgress = lazy(() => import('../views/pages/WorkInProgress'));
const Dashboard = lazy(() => import('../views/pages/Dashboard/Dashboard/HomeDashboard'));
const TwilioVIPOTest = lazy(() => import('../views/pages/TwilioTest/TwilioVIPOTest'));
const TwilioVtnaTest = lazy(() => import('../views/pages/TwilioTest/TwilioVTNATest'));
const TwilioPaymentTest = lazy(() => import('../views/pages/TwilioTest/TwilioPayment'));
const WebRTC = lazy(() => import('../views/pages/Demo/demo'));
const DemoWebRTC = lazy(() => import('../views/pages/TwilioTest/WebRTC'));
const ElevenLabs = lazy(() => import('../views/pages/TwilioTest/Eleven-Labs'));
const Irop = lazy(() => import('../views/pages/TwilioTest/Irop'));
const WhatsAppOnboarding = lazy(() => import('../views/pages/TwilioTest/WhatsAppOnboarding'));

const CallFlow = lazy(() => import('../views/pages/Dashboard/CallFlow/CallFlow'));
// const FastLaneView = lazy(() => import('../views/pages/Dashboard/PricingRules/FastLaneView'));
const FastLaneView = lazy(() => import('../views/pages/Dashboard/PricingRules/FastLaneView'));
const PayPhoneView = lazy(() => import('../views/pages/Dashboard/PricingRules/CallPassView'));
const VtnaView = lazy(() => import('../views/pages/Dashboard/PricingRules/VtnaView'));
const VippView = lazy(() => import('../views/pages/Dashboard/PricingRules/VippView'));
const API = lazy(() => import('../views/pages/Dashboard/InterConnection/API'));
const VoIP = lazy(() => import('../views/pages/Dashboard/InterConnection/VoIP'));
const IVR = lazy(() => import('../views/pages/Dashboard/InterConnection/IVR'));
const Accounts = lazy(() => import('../views/pages/Dashboard/Settings/Accounts'));
const RegionPricing = lazy(() => import('../views/pages/Dashboard/Settings/RegionPricing'));
const Twilio = lazy(() => import('../views/pages/Dashboard/Settings/Twilio')); //TODO: I need to change this.
const DIDWW = lazy(() => import('../views/pages/Dashboard/Settings/DIDWW'));
const DIDWWManagement = lazy(() => import('../views/pages/Dashboard/Settings/DIDManagement'));
const RegionPricingDID = lazy(() => import('../views/pages/Dashboard/Settings/RegionPricingDID'));

const Users = lazy(() => import('../views/pages/Dashboard/Settings/Users'));
const Roles = lazy(() => import('../views/pages/Dashboard/Settings/Roles'));
const Products = lazy(() => import('../views/pages/Dashboard/Products/ProductsView'));
const WebRTCProduct = lazy(() => import('../views/pages/Dashboard/WebRTC/WebRTCView'));
const CDRReports = lazy(() => import('../views/pages/Dashboard/WebRTC/CDRReportsView'));
const CDRDashboard = lazy(() => import('../views/pages/Dashboard/WebRTC/CDRDashboard'));
const ProviderCallFailures = lazy(() =>
  import('../views/pages/Dashboard/ProviderCallFailures/ProviderCallFailuresView')
);

//wtsp
const WhatsAppReports = lazy(() =>
  import('../views/pages/Dashboard/WhatsAppReports/WhatsappReportsView')
);
const WhatsAppDashboard = lazy(() =>
  import('../views/pages/Dashboard/WhatsAppReports/WhatsappDashboard')
);
const WhatsAppLinksView = lazy(() =>
  import('../views/pages/Dashboard/WhatsAppReports/WhatsAppLinksView')
);
// did
const DIDProduct = lazy(() => import('../views/pages/Dashboard/DID/DIDView'));
const DIDReports = lazy(() => import('../views/pages/Dashboard/DID/DIDReportsView'));
const DIDDashboard = lazy(() => import('../views/pages/Dashboard/DID/DIDDashboard'));

const LookUpView = lazy(() => import('../views/pages/Dashboard/LookUp/LookUpView'));
const LookUpAccessLogs = lazy(() => import('../views/pages/Dashboard/LookUp/LookUpAccessLogs'));

// reports
const CDRsReport = lazy(() => import('../views/pages/Dashboard/Reports/CDRsReportView'));
const ConfigJobs = lazy(() => import('../views/pages/Dashboard/Cronjobs/ConfigJobs'));
const ExecutionJobs = lazy(() => import('../views/pages/Dashboard/Cronjobs/ExecutionJobs'));
const ExecutionLogs = lazy(() => import('../views/pages/Dashboard/Cronjobs/ExecutionLogs'));

// invoicing
const InvoicingDashboard = lazy(() =>
  import('../views/pages/Dashboard/Invoicing/InvoicingDashboard')
);
const InvoicesList = lazy(() => import('../views/pages/Dashboard/Invoicing/InvoicesList'));
const InvoiceDetail = lazy(() => import('../views/pages/Dashboard/Invoicing/InvoiceDetail'));

const privateRoutes = [
  {
    path: '/demos/quickpay',
    exact: true,
    name: 'QuickPay',
    element: TwilioPaymentTest
  },
  {
    path: '/demos/web-rtc',
    exact: true,
    name: 'WebRTCOld',
    element: WebRTC
  },
  {
    path: '/demos/vipo',
    exact: true,
    name: 'VIPO',
    element: TwilioVIPOTest
  },
  {
    path: '/demos/ventana',
    exact: true,
    name: 'Vnta',
    element: TwilioVtnaTest
  },
  {
    path: '/demos/eleven-labs',
    exact: true,
    name: 'AI Agent',
    element: ElevenLabs
  },
  {
    path: '/demos/webrtc',
    exact: true,
    name: 'WebRTC',
    element: DemoWebRTC
  },
  {
    path: '/demos/whatsapp',
    exact: true,
    name: 'Irops',
    element: Irop
  },
  {
    path: '/demos/whatsapp-onboarding',
    exact: true,
    name: 'WhatsApp Onboarding',
    element: WhatsAppOnboarding
  },
  {
    path: '/documentation',
    exact: true,
    name: 'Dashboard',
    element: APIDocumentation
  },
  {
    path: '/dashboard',
    exact: true,
    name: 'Dashboard',
    element: Dashboard
  },
  {
    path: '/navigator',
    exact: true,
    name: 'Access Numbers',
    element: CallFlow
  },
  {
    path: '/fastlane',
    exact: true,
    name: 'FastLane',
    element: FastLaneView
  },
  {
    path: '/fastlane/hub',
    exact: true,
    name: 'Hub',
    element: FastLaneHubView
  },
  {
    path: '/payphone',
    exact: true,
    name: 'CallPass',
    element: PayPhoneView
  },
  {
    path: '/payphone/hub',
    exact: true,
    name: 'Hub',
    element: PayPhoneHubView
  },
  {
    path: '/vipp',
    exact: true,
    name: 'Vipp',
    element: VippView
  },
  {
    path: '/vipp/hub',
    exact: true,
    name: 'Hub',
    element: VippHubView
  },
  {
    path: '/vnta',
    exact: true,
    name: 'Ventana',
    element: VtnaView
  },
  {
    path: '/vnta/hub',
    exact: true,
    name: 'Hub',
    element: VtnaHubView
  },
  { path: '/web-rtc-dashboard', exact: true, name: 'Hub', element: CDRDashboard },
  { path: '/cdr-reports', exact: true, name: 'Reports', element: CDRReports },
  { path: '/web-rtc', exact: true, name: 'WebRTC', element: WebRTCProduct },
  //wtsp
  { path: '/whatsapp-dashboard', exact: true, name: 'Hub', element: WhatsAppDashboard },
  { path: '/whatsapp-reports', exact: true, name: 'Reports', element: WhatsAppReports },
  { path: '/whatsapp-links', exact: true, name: 'Custom Links', element: WhatsAppLinksView },
  // did
  { path: '/did-dashboard', exact: true, name: 'Hub', element: DIDDashboard },
  { path: '/did-reports', exact: true, name: 'Reports DID', element: DIDReports },
  { path: '/did', exact: true, name: 'DID', element: DIDProduct },
  { path: '/look-up', exact: true, name: 'Look-up', element: LookUpView },
  {
    path: '/look-up/access-logs',
    exact: true,
    name: 'Look-up Access Logs',
    element: LookUpAccessLogs
  },
  { path: '/calls', exact: true, name: 'Reports', element: Reports },
  { path: '/payments', exact: true, name: 'Reports', element: Reports },
  { path: '/revenue', exact: true, name: 'Reports', element: Reports },
  { path: '/cdrs-reports', exact: true, name: 'Reports', element: CDRsReport },
  // invoicing
  {
    path: '/invoicing-dashboard',
    exact: true,
    name: 'Invoicing Dashboard',
    element: InvoicingDashboard
  },
  { path: '/invoices', exact: true, name: 'Invoices', element: InvoicesList },
  { path: '/invoices/:id', exact: true, name: 'Invoice Detail', element: InvoiceDetail },
  { path: '/api', exact: true, name: 'API', element: API },
  { path: '/voip', exact: true, name: 'VoIP', element: VoIP },
  {
    path: '/ivr-config',
    exact: true,
    name: 'IVR Configuration',
    element: IVR
  },
  {
    path: '/products',
    exact: true,
    name: 'Products',
    element: Products
  },
  {
    path: '/accounts',
    exact: true,
    name: 'Accounts',
    element: Accounts
  },
  {
    path: '/accounts-v2',
    exact: true,
    name: 'Accounts V2',
    element: AccountsV2
  },
  {
    path: '/accounts-v2/details/:id',
    exact: true,
    name: 'Accounts details',
    element: AccountsV2Details
  },
  {
    path: '/accounts-v2/create',
    exact: true,
    name: 'Accounts new',
    element: AccountsV2Details
  },
  {
    path: '/twilio-settings',
    exact: true,
    name: 'Twilio',
    element: Twilio
  },
  {
    path: '/did-buy',
    exact: true,
    name: 'Buy (Conecta)',
    element: DIDWW
  },
  {
    path: '/did-manage',
    exact: true,
    name: 'Inventory',
    element: DIDWWManagement
  },
  {
    path: '/region-pricing-did',
    exact: true,
    name: 'Region Pricing DID',
    element: RegionPricingDID
  },
  {
    path: '/region-pricing',
    exact: true,
    name: 'Region Pricing',
    element: RegionPricing
  },
  { path: '/users', exact: true, name: 'Users', element: Users },
  {
    path: '/security',
    exact: true,
    name: 'Roles',
    element: Roles
  },
  {
    path: '/support',
    exact: true,
    name: 'Support',
    element: WorkInProgress
  },
  {
    path: '/cronjobs/config-jobs',
    exact: true,
    name: 'Config Jobs',
    element: ConfigJobs
  },
  {
    path: '/cronjobs/execution-jobs',
    exact: true,
    name: 'Execution Jobs',
    element: ExecutionJobs
  },
  {
    path: '/cronjobs/execution-jobs/:id/logs',
    exact: true,
    name: 'Execution Logs',
    element: ExecutionLogs
  },
  {
    path: '/provider-call-failures',
    exact: true,
    name: 'Provider Call Failures',
    element: ProviderCallFailures
  },
  { path: '*', name: 'Page Not Found', element: PageNotFound }
];

export default privateRoutes;
